import { render } from "./BarcodeError.vue?vue&type=template&id=644a9ca0&scoped=true"
import script from "./BarcodeError.vue?vue&type=script&lang=js"
export * from "./BarcodeError.vue?vue&type=script&lang=js"

import "./BarcodeError.vue?vue&type=style&index=0&id=644a9ca0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-644a9ca0"]])

export default __exports__